// 通用组件
import TmsVideo from './components/TmsVideo/index';
import TmsTitle from './components/TmsTitle/index';
import TmsText from './components/TmsText/index';
import TmsButton from './components/TmsButton/index';
import TmsImageSet from './components/TmsImageSet/index.vue';
import TmsSplitLine from './components/TmsSplitLine/index';
import TmsShopHeader from './components/TmsShopHeader/index';
import TmsCustomMenu from './components/TmsCustomMenu/index';
import TmsTopNav from './components/TmsTopNav/index';
import TmsNoticeBoard from './components/TmsNoticeBoard/index';
import TmsMiddleNav from './components/TmsMiddleNav/index.vue';
import TmsBottomNav from './components/TmsBottomNav/index.vue';
import TmsImageList from './components/TmsImageList/index';
import TmsContactInfo from './components/TmsContactInfo/index.vue';
import TmsBackTop from './components/TmsBackTop/index';
import TmsRule from './components/TmsRule/index';
import TmsCountdown from './components/TmsCountdown/index';
import TmsCopyText from './components/TmsCopyText/index';
import TmsAnchor from './components/TmsAnchor/index.vue';
import TmsJumpApp from './components/TmsJumpApp/index';
import TmsBottomFloat from './components/TmsBottomFloat/index';
import TmsFixIcon from './components/TmsFixIcon/index.vue';
import TmsSwiperNav from './components/TmsSwiperNav/index';
import TmsNewcomerReport from './components/TmsNewcomerReport/index.vue';
// 业务
import TmsBizItem from './components/TmsBizItem/index';
import TmsActiveItem from './components/TmsActiveItem/index';

//营销
import TmsBizRedPacket from './components/TmsBizRedPacket/index';
import TmsForm from './components/TmsForm/index';
import TmsUserKpi from './components/TmsUserKpi/index';
import TmsActiveDay from './components/TmsActiveDay/index';
import TmsActiveDay2 from './components/TmsActiveDay2/index';
import TmsActiveDay3 from './components/TmsActiveDay3/index';
import TmsActiveSpecial from './components/TmsActiveSpecial/index';
import TmsActiveMaterial from './components/TmsActiveMaterial/index';

import TmsModuleConfig from './components/TmsModuleConfig/index.vue';
import TmsPageConfig from './components/TmsPageConfig/index.vue';
import * as FieldTypes from './components/field-type';
import * as Helper from '@/views/cms/helper';

const TmsPlugin = {
  install(Vue) {
    // 字段类型配置元素

    for (let key in FieldTypes) {
      Vue.component(key, FieldTypes[key]);
    }
    // 链接助手
    for (let key in Helper) {
      Vue.component(key, Helper[key]);
    }

    // 配置区
    Vue.component('tms-module-config', TmsModuleConfig);
    // 页面配置
    Vue.component('tms-page-config', TmsPageConfig);

    // 通用组件
    Vue.component('tms-newcomer_report', TmsNewcomerReport);
    Vue.component('tms-swiper_nav', TmsSwiperNav);
    Vue.component('tms-video', TmsVideo);
    Vue.component('tms-title', TmsTitle);
    Vue.component('tms-text', TmsText);
    Vue.component('tms-button', TmsButton);
    Vue.component('tms-image_set', TmsImageSet);
    Vue.component('tms-split_line', TmsSplitLine);
    Vue.component('tms-biz_item', TmsBizItem);
    Vue.component('tms-biz_active_item', TmsActiveItem);
    Vue.component('tms-shop_header', TmsShopHeader);
    Vue.component('tms-custom_menu', TmsCustomMenu);
    Vue.component('tms-top_nav', TmsTopNav);
    Vue.component('tms-notice_board', TmsNoticeBoard);
    Vue.component('tms-middle_nav', TmsMiddleNav);
    Vue.component('tms-bottom_nav', TmsBottomNav);
    Vue.component('tms-image_list', TmsImageList);
    Vue.component('tms-contact_info', TmsContactInfo);
    Vue.component('tms-back_top', TmsBackTop);
    Vue.component('tms-rule', TmsRule);
    Vue.component('tms-countdown', TmsCountdown);
    Vue.component('tms-copy_text', TmsCopyText);
    Vue.component('tms-anchor', TmsAnchor);
    Vue.component('tms-jump_app', TmsJumpApp);
    Vue.component('tms-bottom_float', TmsBottomFloat);
    Vue.component('tms-fix_icon', TmsFixIcon);

    //营销组件
    Vue.component('tms-biz_red_packet', TmsBizRedPacket);
    Vue.component('tms-form', TmsForm);
    Vue.component('tms-user_kpi', TmsUserKpi);

    // 商品玩法
    Vue.component('tms-active_day', TmsActiveDay);
    Vue.component('tms-active_day2', TmsActiveDay2);
    Vue.component('tms-active_day3', TmsActiveDay3);
    Vue.component('tms-active_special', TmsActiveSpecial);
    Vue.component('tms-active_material', TmsActiveMaterial);
  }
};

export default TmsPlugin;

// 供单独引用
export { TmsTitle };